export default __webpack_public_path__ + "static/media/Clean-Air-Forum-Photo-22.962ba36a.jpg";